import React from 'react';

type AppProps = {
  serviceType: string;
  handleChange: (event: any) => void;
  placeholder: string;
  autoFocus?: boolean;
  maxLength?: number;
}

const SevicesInput = ({
  serviceType,
  handleChange,
  placeholder,
  autoFocus,
  maxLength
}: AppProps) => {
  return (
    <>
      <div className="form-group">
        <div className="float-label">
          <label htmlFor="ifsc"
            className={serviceType ? "active" : ""}
          >{placeholder}</label>
          <input
            type="text"
            className="form-control"
            name="IFSC code"
            value={serviceType}
            required
            autoComplete="IFSC code"
            autoFocus={autoFocus}
            onChange={handleChange}
            maxLength={maxLength}
          />
        </div>
      </div>
    </>
  )
};

export default SevicesInput;